package com.exura.pages.planCreator.components.seriesViews.inputs

import androidx.compose.runtime.*
import com.exura.features.plandefinition.domain.model.series.HourOfDay
import com.exura.features.plandefinition.domain.model.series.PartOfDay
import com.exura.pages.planCreator.components.seriesViews.sections.EditViewSection
import com.exura.ui.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

enum class TimeSelectionMode {
    PARTS_OF_DAY,
    SPECIFIC_TIMES;
}

fun timeSelectionModeOption(
    mode: TimeSelectionMode,
    onModeChange: (TimeSelectionMode) -> Unit = {},
): ModeOption<TimeSelectionMode> = when (mode) {
    TimeSelectionMode.PARTS_OF_DAY -> ModeOption(
        onClick = { onModeChange(TimeSelectionMode.PARTS_OF_DAY) }
    ) {
        SpanText("Części dnia")
    }
    TimeSelectionMode.SPECIFIC_TIMES -> ModeOption(
        onClick = { onModeChange(TimeSelectionMode.SPECIFIC_TIMES) }
    ) {
        SpanText("Konkretne godziny")
    }
}

@Composable
internal fun TimeSelectionSection(
    selectedMode: TimeSelectionMode,
    onModeChange: (TimeSelectionMode) -> Unit,
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
    // Parts of day parameters
    selectedPartsOfDay: List<PartOfDay> = emptyList(),
    onPartsOfDayChange: (List<PartOfDay>) -> Unit = {},
    // Specific times parameters
    selectedSpecificTimes: List<HourOfDay> = emptyList(),
    onSpecificTimesChange: (List<HourOfDay>) -> Unit = {},
) {
    // State persistence for both modes
    var podState by remember { mutableStateOf(selectedPartsOfDay) }
    var todState by remember { mutableStateOf(selectedSpecificTimes) }

    // Update local state when external state changes
    LaunchedEffect(selectedPartsOfDay) {
        if (selectedMode == TimeSelectionMode.PARTS_OF_DAY) {
            podState = selectedPartsOfDay
        }
    }

    LaunchedEffect(selectedSpecificTimes) {
        if (selectedMode == TimeSelectionMode.SPECIFIC_TIMES) {
            todState = selectedSpecificTimes
        }
    }

    EditViewSection(
        enabled = enabled,
        title = "O której porze?",
        withTitle = false,
    ) { isEnabled ->
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(16.px)
        ) {
            // Content based on selected mode
            when (selectedMode) {
                TimeSelectionMode.PARTS_OF_DAY -> {
                    PartsOfDaySelector(
                        selectedParts = podState,
                        onSelectionChange = { newSelection ->
                            podState = newSelection
                            onPartsOfDayChange(newSelection)
                        },
                        mode = mode,
                        enabled = isEnabled
                    )
                }
                TimeSelectionMode.SPECIFIC_TIMES -> {
                    TimeOfDaySelector(
                        selectedTimes = todState,
                        onSelectionChange = { newSelection ->
                            todState = newSelection
                            onSpecificTimesChange(newSelection)
                        },
                        mode = mode,
                        enabled = isEnabled
                    )
                }
            }
            // Mode selector
            ModeSelectorInput(
                options = listOf(TimeSelectionMode.PARTS_OF_DAY, TimeSelectionMode.SPECIFIC_TIMES),
                optionToMode = { timeMode ->
                    timeSelectionModeOption(
                        mode = timeMode,
                        onModeChange = onModeChange,
                    )
                },
                selectedValue = selectedMode,
                mode = mode,
                enabled = isEnabled,
            )
        }
    }
}